import React from 'react'
import PropTypes from 'prop-types'

import { Motion } from 'Components/UI'

import find from 'lodash/find'
import map from 'lodash/map'
import size from 'lodash/size'

import { PLATFORMS } from 'Constants/Projects/platforms'

import Plate from './plate'
import { Container } from './styles'

function Plates({ columns, data, invert, ...rest }) {
  if (!size(data)) return null

  return (
    <Container columns={columns} {...rest}>
      {map(data, entity => {
        const platform = find(PLATFORMS, { title: entity.platformName })
        return (
          <Motion key={entity?.id}>
            <Plate data={entity} invert={invert} platform={platform} />
          </Motion>
        )
      })}
    </Container>
  )
}

Plates.defaultProps = {
  columns: 1,
  data: [],
  invert: 0,
  platforms: [],
}

Plates.propTypes = {
  columns: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  data: PropTypes.array,
  invert: PropTypes.number,
  platforms: PropTypes.array,
}

export default Plates
